{
	"nav": {
		"features": "Funciones",
		"pricing": "Precios",
		"about": "Nosotros",
		"careers": "Empleo",
		"contact": "Contacto",
		"sign_in": "Iniciar sesión",
		"sign_up_free": "Crear cuenta gratis",
		"open_menu": "Abrir menú",
		"close_menu": "Cerrar menú"
	},
	"footer": {
		"product": "Producto",
		"company": "Empresa",
		"legal": "Legal",
		"features": "Funciones",
		"pricing": "Precios",
		"demo": "Demo en vivo",
		"about": "Nosotros",
		"careers": "Empleo",
		"contact": "Contacto",
		"privacy": "Privacidad",
		"terms": "Términos",
		"legal_notices": "Aviso legal",
		"tagline": "Tu comunidad. Tu marca. Impulsada por IA.",
		"rights": "© {{year}} UpSquad, Inc. Todos los derechos reservados.",
		"language": "Idioma"
	},
	"cta": {
		"book_demo": "Reservar una demo",
		"learn_more": "Saber más",
		"talk_to_sales": "Hablar con ventas",
		"contact_us": "Contáctanos",
		"sign_up_free": "Crear cuenta gratis"
	},
	"not_found": {
		"meta_title": "Página no encontrada",
		"eyebrow": "Error 404",
		"title": "Esta página no existe.",
		"body": "Puede que el enlace esté roto o que la página se haya movido. Vuelve a la página de inicio para seguir explorando UpSquad.",
		"back_home": "Volver al inicio"
	},
	"toast": {
		"contact_success": "Mensaje enviado — te responderemos en breve.",
		"contact_error": "Algo salió mal. Inténtalo de nuevo.",
		"contact_rate_limit": "Demasiadas solicitudes. Intenta de nuevo en un minuto."
	}
}
